import { supabase } from '../lib/supabase';
import { DeviceFamily } from '../types';

export const deviceService = {
    /**
     * Get all active device families for a specific brand, ordered by display_order.
     */
    async getFamiliesByBrand(brandName: 'Apple' | 'Samsung'): Promise<DeviceFamily[]> {
        // 1. Get Brand ID
        const { data: brandData, error: brandError } = await supabase
            .from('brands')
            .select('id')
            .ilike('name', brandName)
            .limit(1);

        const brand = brandData?.[0];

        if (brandError || !brand) {
            console.error('Error fetching brand:', brandError);
            return [];
        }

        // 2. Get Families
        const { data: families, error: familyError } = await supabase
            .from('device_families')
            .select('*')
            .eq('brand_id', brand.id)
            .eq('is_active', true)
            .order('display_order', { ascending: true });

        if (familyError) {
            console.error('Error fetching families:', familyError);
            return [];
        }

        // 3. Get Models for these families to populate "variants"
        if (!families.length) return [];

        const { data: models, error: modelError } = await supabase
            .from('device_models')
            .select('id, name, family_id')
            .in('family_id', families.map(f => f.id));

        if (modelError) {
            console.error('Error fetching models:', modelError);
            return families;
        }

        return families.map(family => ({
            ...family,
            variants: models
                .filter(m => m.family_id === family.id)
                .map(m => m.name)
                .sort((a, b) => b.localeCompare(a, undefined, { numeric: true }))
        }));
    }
};
